module.exports = __webpack_public_path__ + "img/t7.a172ceff.jpg";